"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const eventBus = new events_1.EventEmitter();
exports.default = eventBus;
